// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { xCommonStateType } from "@steiner/App/Store/Reducers";

export type xCommonHandlerType = {
    key: keyof xCommonStateType;
    value: any;
};

export const DispatchUpdateXCommon: Handler<xCommonHandlerType> = props => {
    props.dispatch({
        type: "xCommon/update",
        data: props.parameter,
    } as any);
};

const xCommonUpdate = createHandlerChainRunner([DispatchUpdateXCommon], "xCommonUpdate");
export default xCommonUpdate;
